<div *ngIf="dataConfig" class="container-block">
  <ng-container *ngIf="!isViewAll">
    <app-position-in-config [elementChoosing]="objectChoosing" [device]="device"
      [idCellFrame]="'cell_frame_'+ objectChoosing._id + '_' +'0'"></app-position-in-config>

    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class['frame-product-category']['width']" [height]="class['frame-product-category']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      
      <!-- Hiển thị -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="main-config">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>

          <app-background-image-config [showImageConfig]="false" [elementChoosing]="objectChoosing" [config]="config" [class]="class"
            [backgroundClass]="class['frame-product-category']" [backgroundConfig]="dataConfig" [isBlock]="false"
            [id_object]="objectChoosing._id" [device]="device">
          </app-background-image-config>

          <!-- Thay đổi màu thẻ chứa cụm nút phân trang-->
          <div class="config-name">
            <p>Màu nền cụm nút phân trang</p>
            <input class="input-color"  type="button"
              [style.background]="class['frame-product-category__pagination']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>

        </div>
      </li>

      <!-- * Dùng cho frame-room-by-category -->
      <!-- GIÁ HIỂN THỊ -->
      <li *ngIf="objectChoosing.component === 'AtwFrameRoomByCategory'" 
        nz-submenu [nzTitle]="'gia_hien_thi' | translate" [(nzOpen)]="openMap.menu99" (nzOpenChange)="openHandler('menu99')">
        <div class="mb-3">
          <nz-select [(ngModel)]="config['price_display']['field_name']" (ngModelChange)="updateConfig()">
            <nz-option nzValue="first_hour" [nzLabel]="'gia_gio_dau' | translate"></nz-option>
            <nz-option nzValue="second_hour" [nzLabel]="'gia_gio_sau' | translate"></nz-option>
            <nz-option nzValue="night" [nzLabel]="'gia_dem' | translate"></nz-option>
            <nz-option nzValue="day" [nzLabel]="'gia_ngay' | translate"></nz-option>
          </nz-select>
        </div>
      </li>

      <!-- Kiểu dạng và chia cột -->
      <li nz-submenu nzTitle="Kiểu dạng và chia cột" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-total-row-col-products-config [objectChoosing]="objectChoosing" [config]="config" [class]="class"
          [productsClass]="class['frame-product-category__list']" [productsConfig]="config"
          [id_object]="objectChoosing._id" [device]="device">
        </app-total-row-col-products-config>
      </li>
      <!-- Nút phân trang -->
      <li nz-submenu nzTitle="Nút phân trang" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="pl-1" nz-submenu nzTitle="Thiết lập chung" [(nzOpen)]="openMap.menu5">
          <div class="editor-field">
            <!-- Ẩn nút phân trang -->
            <div class="config-name" style="padding-bottom:5px">
              <div class="title-font">
                Ẩn nút phân trang
              </div>
              <nz-switch [(ngModel)]="config['frame-product-category__pagination']['hide_pagination']" (ngModelChange)="class['frame-product-category__pagination']['display'] =
                !$event ? 'flex' : 'none';updateConfig();updateClass()"></nz-switch>
            </div>
            <!-- Vị trí cụm nút phân trang -->
            <div>
              <div class="title mb-1 mt-0">Vị trí cụm nút phân trang</div>
              <nz-radio-group style="display:flex; flex-direction:column;"
                [(ngModel)]="class['frame-product-category__pagination']['justify-content']"
                (ngModelChange)="updateClass()">
                <label nz-radio nzValue="flex-start">Trái</label>
                <label nz-radio nzValue="center">Giữa</label>
                <label nz-radio nzValue="flex-end">Phải</label>
              </nz-radio-group>
            </div>
            <!-- Khoảng cách giữa các nút -->
            <div>
              <div class="config-name mb-0">
                <p>Khoảng cách giữa các nút</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['frame-product-category__pagination-list-button']['gap'] | vhnumber"
                  (ngModelChange)="class['frame-product-category__pagination-list-button']['gap'] = $event + 'px'"
                  (nzBlur)="updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button']['gap'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button']['gap'] = $event + 'px'"
                (nzOnAfterChange)="updateClass()">
              </nz-slider>
            </div>

            <!-- Khoảng cách giữa các nút với cột sản phẩm -->
            <div>
              <div class="config-name mb-0">
                <p>Khoảng cách giữa nút và sản phẩm</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['frame-product-category__list']['padding-bottom'] | vhnumber"
                  (ngModelChange)="class['frame-product-category__list']['padding-bottom'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-product-category__list']['padding-bottom'] | vhnumber"
                (ngModelChange)="class['frame-product-category__list']['padding-bottom'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Chỉnh chiều cao của cụm nút phân trang-->
            <div>
              <div class="config-name mb-0">
                <p>Chiều cao của cụm nút phân trang</p>
                <nz-input-number [nzMin]="50" [nzMax]="100" [nzStep]="1"
                  [ngModel]="class['frame-product-category__pagination']['height'] | vhnumber"
                  (ngModelChange)="class['frame-product-category__pagination']['height'] = $event + 'px'"
                  (nzBlur)=" updateClass()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="50" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination']['height'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination']['height'] = $event + 'px'"
                (nzOnAfterChange)=" updateClass()">
              </nz-slider>
            </div>

            <!--Ẩn nút biểu tượng-->
            <div>
              <div class="config-name mb-0">
                <p>Ẩn nút biểu tượng</p>
                <nz-switch [ngModel]="config['icon_pagination']['display']" (ngModelChange)="class['frame-product-category__pagination-list-button--controll']['display'] =
                                  !$event ? 'flex' : 'none'; config['icon_pagination']['display'] = $event"
                  (nzOnAfterChange)="updateConfig();updateClass()"></nz-switch>
              </div>
            </div>
            <!--Ẩn nút Tới trang-->
            <div>
              <div class="config-name mb-0">
                <p>Ẩn nút tới trang</p>
                <nz-switch [(ngModel)]="config['goToPage_pagination']['display']"
                  (ngModelChange)="updateConfig()"></nz-switch>
              </div>
            </div>
            <!-- Chọn Font -->
            <div class="d-flex justify-content-between align-items-center">
              <mat-form-field class="w-100">
                <mat-label>Font</mat-label>
                <mat-select [(ngModel)]="class['frame-product-category__pagination-list-button']['font-family']"
                  (ngModelChange)="updateClass()">
                  <mat-option *ngFor="let font of fonts" [value]="font.value">
                    {{font.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- set HCN hoặc Hình Tròn -->
            <div>
              <div class="config-name mb-0" style="flex-direction: column;">
                <p class="mb-3">{{'kieu_nut_slide' | translate}}</p>
                <nz-radio-group [(ngModel)]="config['slick_dots']['background_style']"
                  (ngModelChange)="handleSetDotsStyle($event)">
                  <label nz-radio nzValue="circle">{{'hinh_tron' | translate}}</label>
                  <label nz-radio nzValue="rectangle">{{'hinh_chu_nhat' | translate}}</label>
                </nz-radio-group>
                <!-- Kích thước nút (chiều rộng) -->
                <div *ngIf="config['slick_dots']['background_style'] == 'circle'">
                  <div class="config-name">
                    <p>Kích thước nút</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['width'] | vhnumber" (ngModelChange)="handleSetButtonSize($event)"
                      (nzOnAfterChange)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['width'] | vhnumber"
                    (ngModelChange)="handleSetButtonSize($event)" (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                </div>
                <!-- Kích thước nút (chiều cao) -->
                <div *ngIf="config['slick_dots']['background_style'] == 'rectangle'">
                  <div class="config-name">
                    <p>Kích thước nút (chiều rộng)</p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['width'] | vhnumber"
                      (ngModelChange)="config['slick_dots']['width'] = $event+'px'"
                      (nzBlur)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['width'] | vhnumber"
                    (ngModelChange)="config['slick_dots']['width'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                  <div class="config-name">
                    <p>{{'kich_thuoc_nut_(_chieu_cao_)' | translate}} </p>
                    <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                      [ngModel]="config['slick_dots']['height'] | vhnumber"
                      (ngModelChange)="config['slick_dots']['height'] = $event+'px'"
                      (nzBlur)="updateConfig(); updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1" [ngModel]="config['slick_dots']['height'] | vhnumber"
                    (ngModelChange)="config['slick_dots']['height'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                  </nz-slider>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!-- Thiết lập nút chưa chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="Thiết lập nút chưa chọn" [(nzOpen)]="openMap.menu6">
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">Màu chữ</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--page-number']['color']"
                [style.background]="class['frame-product-category__pagination-list-button--page-number']['color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>Cỡ chữ</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--page-number']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--page-number']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--page-number']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--page-number']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="item my-2">
            <div class="title-font">Màu viền nút</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--page-number']['border-color']"
                [style.background]="class['frame-product-category__pagination-list-button--page-number']['border-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}} </p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--page-number']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--page-number']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--page-number']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--page-number']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title mt-0">{{'mau_nen' | translate}} </div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--page-number']['background-color']"
                [style.background]="
                  class['frame-product-category__pagination-list-button--page-number']['background-color']
                " [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>Bo tròn</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--page-number']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--page-number']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--page-number']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút được chọn -->
        <div class="px-1 li-config" nz-submenu nzTitle="Thiết lập nút được chọn" [(nzOpen)]="openMap.menu7">
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">Màu chữ</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--active']['color']"
                [style.background]="class['frame-product-category__pagination-list-button--active']['color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Cỡ chữ -->
          <div>
            <div class="config-name mb-0">
              <p>Cỡ chữ</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--active']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--active']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--active']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--active']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu viền nút -->
          <div class="item my-2">
            <div class="title-font">Màu viền nút</div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--active']['border-color']"
                [style.background]="class['frame-product-category__pagination-list-button--active']['border-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}} </p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--active']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--active']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--active']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--active']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <hr class="my-4" style="border-top: 1px solid rgb(223 223 223)" />
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title mt-0">{{'mau_nen' | translate}} </div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--active']['background-color']"
                [style.background]="class['frame-product-category__pagination-list-button--active']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>Bo tròn</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--active']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--active']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--active']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--active']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div class="px-1 li-config" nz-submenu nzTitle="Thiết lập nút chuyển trang" [(nzOpen)]="openMap.menu8">
          <!-- Sử dụng icon -->
          <div class="item mt-3">
            <div class="title-font">Sử dụng icon</div>
            <nz-switch [(ngModel)]="dataConfig.icon_pagination.icon" (ngModelChange)="updateConfig()"></nz-switch>
          </div>
          <!-- Kiểu icon -->
          <div class="item">
            <div class="title-font">Kiểu icon</div>
            <button [disabled]="!dataConfig.icon_pagination.icon" nz-button nz-dropdown [nzDropdownMenu]="menu" style="
                  width: 50%;
                  padding: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                " [nzPlacement]="positionSelect">
              <div style="
                    font-size: 18px;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                  ">
                <i [class]="dataConfig.icon_pagination.arrow_left_icon"></i>
                <i [class]="dataConfig.icon_pagination.arrow_right_icon"></i>
              </div>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item *ngFor="let item of bootstrapIconArrows" style="justify-content: center"
                  (click)="onChangeArrows(item)">
                  <div style="
                        font-size: 18px;
                        display: flex;
                        justify-content: space-around;
                        padding: 10px 0px;
                      ">
                    <i [class]="item.icon_left"></i>
                    <i [class]="item.icon_right"></i>
                  </div>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <div class="item mt-3">
            <div class="title-font">Sử dụng nội dung</div>
          </div>
          <div class="item">
            <div class="title-font">Trước</div>
            <input [disabled]="dataConfig.icon_pagination.icon" style="width: 50%" nz-input placeholder="Trước"
              [(ngModel)]="dataConfig.content_pagination.content_left" (ngModelChange)="updateConfig()" />
          </div>
          <div class="item">
            <div class="title-font">Sau</div>
            <input [disabled]="dataConfig.icon_pagination.icon" style="width: 50%" nz-input placeholder="Sau"
              [(ngModel)]="dataConfig.content_pagination.content_right" (ngModelChange)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title-font">{{'mau_nen' | translate}} </div>
            <div class="color-pick">
              <input class="input-color"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--controll']['background-color']"
                [style.background]="class['frame-product-category__pagination-list-button--controll']['background-color']"
                [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">Màu chữ</div>
            <div class="color-pick">
              <input class="input-color" [cpPositionOffset]="'-200%'" [cpWidth]="'230px'"
                [cpPositionRelativeToArrow]="true"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--controll']['color']"
                [style.background]="class['frame-product-category__pagination-list-button--controll']['color']"
                [cpPosition]="'top'" (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>Cỡ chữ</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--controll']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--controll']['font-size'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--controll']['font-size'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--controll']['font-size'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}} </p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--controll']['border-width'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--controll']['border-width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--controll']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--controll']['border-width'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div class="item">
            <div class="title-font">Chọn màu viền</div>
            <div class="color-pick">
              <input class="input-color" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true"  type="button"
                [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__pagination-list-button--controll']['border-color']"
                [style.background]="class['frame-product-category__pagination-list-button--controll']['border-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>Bo tròn</p>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-product-category__pagination-list-button--controll']['border-radius'] | vhnumber"
                (ngModelChange)="class['frame-product-category__pagination-list-button--controll']['border-radius'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
              [ngModel]="class['frame-product-category__pagination-list-button--controll']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-product-category__pagination-list-button--controll']['border-radius'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
        <!-- Thiết lập nút chuyển trang -->
        <div *ngIf="!config['goToPage_pagination']['display']" class="px-1 li-config" nz-submenu
          nzTitle="Thiết lập nút tới trang" [(nzOpen)]="openMap.menu9">

          <div class="item mt-3">
            <div class="title-font">Sử dụng nội dung</div>
          </div>
          <div class="item">
            <div class="title-font">Tới Trang</div>
            <input style="width: 50%" nz-input placeholder="Tới Trang"
              [(ngModel)]="config['goToPage_pagination']['content_goToPage']" (ngModelChange)="updateConfig()" />
          </div>
          <!-- Màu nền -->
          <div class="item my-2">
            <div class="title-font">{{'mau_nen' | translate}} </div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['background_color']"
                [style.background]="config['goToPage_pagination']['background_color']"
                (colorPickerClose)="updateConfig()"  type="button"/>
            </div>
          </div>
          <!-- Màu chữ -->
          <div class="item my-2">
            <div class="title-font">Màu chữ</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['color']"  type="button"
                [style.background]="config['goToPage_pagination']['color']" (colorPickerClose)="updateConfig()" />
            </div>
          </div>
          <!-- Kích thước -->
          <div>
            <div class="config-name mb-0">
              <p>Cỡ chữ</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'" (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="1" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['font_size'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['font_size'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Độ dày viền -->
          <div>
            <div class="config-name mb-0">
              <p>{{'do_day_vien' | translate}} </p>
              <nz-input-number [nzMin]="0" [nzMax]="8" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="8" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_width'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_width'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
          <!-- Chọn màu viền -->
          <div class="item">
            <div class="title-font">Chọn màu viền</div>
            <div class="color-pick">
              <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['goToPage_pagination']['border_color']"
                [style.background]="config['goToPage_pagination']['border_color']"
                (colorPickerClose)="updateConfig()"  type="button"/>
            </div>
          </div>
          <!-- Bo tròn -->
          <div>
            <div class="config-name mb-0">
              <p>Bo tròn</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
                (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="config['goToPage_pagination']['border_radius'] | vhnumber"
              (ngModelChange)="config['goToPage_pagination']['border_radius'] = $event + 'px'"
              (nzOnAfterChange)="updateConfig()">
            </nz-slider>
          </div>
        </div>
      </li>
      <!-- Cấu hình các phần tử bên trong -->
      <li nz-submenu nzTitle="Cấu hình phần tử" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <div class="main-config">
          <!-- Màu nền -->
          <div class="config-name mt-0">
            <p>{{'mau_nen' | translate}} </p>
            <input class="input-color"
              [style.background]="class['frame-product-category__list--item']['background-color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-product-category__list--item']['background-color']"
              (colorPickerClose)="updateClass()"  type="button"/>
          </div>

          <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
            [borderClass]="class['frame-product-category__list--item']" [id_object]="objectChoosing._id">
          </app-borders-config>

          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- Cấu hình icon bên trái -->
      <li *ngIf="config['frame-product-category__list']['is_autoplay']" nz-submenu nzTitle="Cấu hình icon trái"
        [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-icon-left-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
          [iconLeftClass]="class['frame-product-category__left-arrow--icon']"
          [iconLeftConfig]="config['frame-product-category__left-arrow--icon']"
          [distanceLeftClass]="class['frame-product-category__left-arrow']" [id_object]="objectChoosing._id">
        </app-icon-left-config>
      </li>
      <!-- Cấu hình icon bên phải -->
      <li *ngIf="config['frame-product-category__list']['is_autoplay']" nz-submenu nzTitle="Cấu hình icon phải"
        [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-icon-right-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [config]="config"
          [iconRightClass]="class['frame-product-category__right-arrow--icon']"
          [iconRightConfig]="config['frame-product-category__right-arrow--icon']"
          [distanceRightClass]="class['frame-product-category__right-arrow']" [id_object]="objectChoosing._id">
        </app-icon-right-config>
      </li>
      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <!-- Đổ bóng -->
        <app-shadow-config [device]="device" [config]="config" [class]="class"
          [shadowClass]="class['frame-product-category']" [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình chữ thông báo kết quả -->
      <li nz-submenu nzTitle="{{'chu_thong_bao_ket_qua' | translate}}" [(nzOpen)]="openMap.menu12"
        (nzOpenChange)="openHandler('menu12')">

        <div class="show-notification-text">
          <p style="line-height: 1.5; line-height: normal;">
            {{'hien_thi' | translate}}
          </p>
          <nz-switch [(ngModel)]="config['show_notification_text']" (ngModelChange)="updateConfig();">
          </nz-switch>
        </div>

        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput [(ngModel)]="objectChoosing.staticdata.text_before_number"
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>
        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput [(ngModel)]="objectChoosing.staticdata.text_after_number"
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>

        <app-text-format-config [device]="device" [objectChoosing]="objectChoosing"
          [staticdata]="objectChoosing.staticdata" [class]="class" [config]="config"
          [textContentClass]="class['frame-product-category__notification-text']"
          [textWrapperClass]="class['frame-product-category__notification-text']">
        </app-text-format-config>

        <div class="font-adjusting">
          <div class="row-spacing">
            <span class="title"> {{'khoang_cach_dong' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="100" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
              [(ngModel)]="class['frame-product-category__notification-text']['line-height']"
              (nzBlur)="updateClass()"></nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="0.1"
            [(ngModel)]="class['frame-product-category__notification-text']['line-height']"
            (nzOnAfterChange)="updateClass()"></nz-slider>
        </div>

      </li>

      <!-- Cấu hình khi không tìm thấy sản phẩm -->
      <li nz-submenu nzTitle="{{'cau_hinh_khi_khong_tim_thay_san_pham' | translate}}" [(nzOpen)]="openMap.menu13"
        (nzOpenChange)="openHandler('menu13')">
        <div class="d-flex justify-content-between align-items-center p-3">
          <p>{{'cau_hinh' | translate}}</p>
          <nz-switch [(ngModel)]="config['is_empty']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <ng-container *ngIf="config['is_empty']">
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput [(ngModel)]="objectChoosing.staticdata.no_data" (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </div>

          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing"
            [staticdata]="objectChoosing.staticdata" [class]="class" [config]="config"
            [textContentClass]="class['frame-product-category__no-data']"
            [textWrapperClass]="class['frame-product-category__no-data']">
          </app-text-format-config>

          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title">{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="30" [ngStyle]="{ width: '40%' }" [ngModel]="
                      class['frame-product-category__no-data']['letter-spacing'] | vhnumber
                    " (nzBlur)="updateClass()" (ngModelChange)="
                      class['frame-product-category__no-data']['letter-spacing'] = $event + 'px'
                    "></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="30"
              [ngModel]="class['frame-product-category__no-data']['letter-spacing'] | vhnumber"
              (nzOnAfterChange)="updateClass()" (ngModelChange)="
                    class['frame-product-category__no-data']['letter-spacing'] = $event + 'px'
                  "></nz-slider>
          </div>
          <div class="font-adjusting">
            <div class="row-spacing">
              <span class="title"> {{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="3" [ngStyle]="{ width: '40%' }" [nzStep]="0.1"
                [(ngModel)]="class['frame-product-category__no-data']['line-height']"
                (nzBlur)="updateClass()"></nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="3" [nzStep]="0.1"
              [(ngModel)]="class['frame-product-category__no-data']['line-height']"
              (nzOnAfterChange)="updateClass()"></nz-slider>
          </div>
        </ng-container>
      </li>

      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu14" (nzOpenChange)="openHandler('menu14')">
        <app-choose-animations-config 
          [elementChoosing]="objectChoosing"
          (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id"
          [device]="device" [class]="class"
          [config]="config" [staticdata]="objectChoosing.staticdata"
          [cursorClass]="class['frame-product-category']"
          [effect_hover]="effect_hover" [customize]="customize"
          [effectFileUsing]="'frame-products'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <div class="editor-header" *ngIf="isViewAll">
    <div class="return" (click)="isViewAll = !isViewAll" style="
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;
        margin-bottom: 5px;
      ">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll" style="font-weight: 500;">
        {{ currentViewAll.title | translate }}</span>
    </div>
  </div>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-product-category__list--item']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['frame-product-category__list--item']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>

      <!-- Bật đổ bóng -->
      <app-shadow-config [device]="device" [config]="config" [class]="class"
        [shadowClass]="class['frame-product-category__list--item']"
        [shadowConfig]="config['frame-product-category__list--item']" [objectChoosing]="objectChoosing">
      </app-shadow-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="objectChoosing.staticdata" [id_object]="objectChoosing._id"
        [customize]="customize" [device]="device"></app-animations-config>
    </div>
  </div>
</div>
